export const fuelInputs = [
  'machineId',
  'name',
  'location',
  'description',
  'startDate',
  'endDate',
  //   'breakdownDetails',
]

export const addFuelTaskInitialState = {
  machineId: null,
  name: null,
  startDate: null,
  endDate: null,
  location: null,
  description: null,
  trips: [],
  breakdownType: null,
  breakdownStartDate: null,
  breakdownEndDate: null,
  breakdownDetails: null,
}

export const fuelTypes = [
  { value: 1, label: 'Diesel' },
  { value: 2, label: 'Benzine' },
  { value: 3, label: 'Gas' },
]

export const fuelConsumptionPeriods = [
  { value: 1, label: '12 Months' },
  { value: 2, label: '30 Days' },
  { value: 3, label: '7 Days' },
  { value: 4, label: '24 hours' },
]
